import React from 'react'
import { Component } from 'reflux'
import { ProductTypeActions, ProductTypeStore, STATUS } from 'Stores/productTypeStore'
import { Button, Form, Input, Row, Col, Label } from 'reactstrap'
import _ from 'lodash'
import CollapsibleCard from 'Components/collapsibleCard'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Fragment } from 'react'

export default class ProductTypeForm extends Component {
  constructor(props) {
    super(props)
    this.stores = [ProductTypeStore]
    this.storeKeys = ['status', 'productTypeDetails']
  }

  resetProductType = () => {
    if (_.get(this.props, 'match.params.ProductTypeID')) {
      ProductTypeActions.getProductTypeDetails(this.props.match.params.ProductTypeID)
    } else {
      ProductTypeActions.createEmptyProductType()
    }
  }

  render() {
    if (this.state.status === STATUS.REDIRECT) {
      return <Redirect to='/product-types' />
    }

    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }

    return (
      <>
        <CollapsibleCard startOpen header={<strong>{_.get(this.props, 'match.params.ProductTypeID') ? 'Detaljer' : 'Opret'}</strong>}>
          <Form>
            <Row className='mb-2'>
              <Col xs='2'>
                <Label for='name'>Navn</Label>
              </Col>
              <Col xs='10'>
                <Input
                  type='text'
                  value={this.state.productTypeDetails.name}
                  name='name'
                  id='name'
                  onChange={ProductTypeActions.updateProductTypeField}
                  invalid={!this.state.productTypeDetails.name.length}
                />
              </Col>
            </Row>
            <Button
              onClick={ProductTypeActions.saveProductType}
              disabled={this.state.status === STATUS.IS_SAVING || !this.state.productTypeDetails.name.length}
            >
              {this.state.status === STATUS.IS_SAVING ? <FontAwesomeIcon icon='spinner' spin /> : 'Gem'}
            </Button>
            <Button color='danger' onClick={this.resetProductType} className='ml-2'>
              Nulstil
            </Button>
          </Form>
        </CollapsibleCard>
      </>
    )
  }
}
